import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

/* PWA "Add to Home Screen" was retired. Any service worker that was
   previously registered (to unlock the install banner) is now unregistered
   here so returning users get a clean state and browsers stop advertising
   the install shortcut. */
if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        navigator.serviceWorker.getRegistrations().then((regs) => {
            regs.forEach((r) => r.unregister());
        }).catch(() => { /* non-fatal */ });
    });
}
